import axios from 'axios';
import API_CONFIG from '../config/api.config';
import customerAuthService from './customerAuthService';

const BASE_URL = `${API_CONFIG.BASE_URL}/public/website`;

export const ecommerceOrderService = {
  /**
   * Place an online order
   * @param {string} websitePath - The website path (e.g., 'mycompany')
   * @param {Object} orderData - Order data containing items, shipping info, etc.
   * @returns {Promise} Order response with order number
   */
  placeOrder: async (websitePath, orderData) => {
    try {
      const token = customerAuthService.getToken();
      const headers = {};
      
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await axios.post(
        `${BASE_URL}/${websitePath}/orders`,
        orderData,
        { headers }
      );

      return response.data;
    } catch (error) {
      console.error('Error placing order:', error);
      throw error.response?.data || { message: 'Failed to place order' };
    }
  }
};

export default ecommerceOrderService;

